import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as actions from '../../inspection/inspection.actions';
import { connect } from 'react-redux';
import { SortableTable } from '../../common/components/table/';
import { withStyles } from 'material-ui/styles';
import { NavLink } from 'react-router-dom';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { getCurrentUserRole, getCurrentUserCompany } from '../../user/user.selectors';
import { UserRoles } from '../../user/user.constants';
const columnData = [
  {
    id: 'identifier',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  { id: 'section', numeric: false, disablePadding: false, label: 'Osasto' },
  { id: 'brand', numeric: false, disablePadding: false, label: 'Merkki' },
  { id: 'model', numeric: false, disablePadding: false, label: 'Malli' },
  {
    id: 'serial',
    numeric: true,
    disablePadding: false,
    label: 'Sarjanumero',
    disableFiltering: true
  },
  {
    id: 'hoursUsed',
    numeric: true,
    disablePadding: false,
    label: 'Tuntilukema',
  },
  { id: 'client', numeric: false, disablePadding: false, label: 'Asiakas' },
  {
    id: 'createdBy',
    numeric: false,
    disablePadding: false,
    label: 'Tarkastanut',
  },
  { id: 'status', numeric: false, disablePadding: false, label: 'Tila' },
  { id: 'order', numeric: false, disablePadding: false, label: 'Työtilaus' },
];
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  headline: {
    color: theme.palette.common.white,
    display: 'flex',
    flex: 1,
    '@media (max-width:599px)': {
      display: 'block',
      textAlign: 'center',
    },
  },
  content: {
    maxWidth: 1040,
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:1040px)': {
      padding: '0 1rem',
    },
    '@media (max-width:599px)': {
      display: 'block',
      textAlign: 'center',
    },
  },
});
class ReportsTable extends Component {
  componentDidMount = () => {
    const {
      readInspections,
      readInspectionTypes,
      readInspectionSchemas,
      readFormDatas,
      company,
    } = this.props;
    readInspections();
    readInspectionTypes(company);
    readInspectionSchemas(company);
    readFormDatas();
  };

  render() {
    const { classes, role } = this.props;
    const isGuest = role === UserRoles.GUEST;
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.wrapper}>
            <Typography
              className={classes.headline}
              type="headline"
              gutterBottom
            >
              Digitaaliset tarkastusraportit
            </Typography>
            {!isGuest && (
              <NavLink to="/inspection/new">
                <Button raised color="accent">
                  Uusi raportti <i className="material-icons">chevron_right</i>
                </Button>
              </NavLink>
            )}
          </div>
          <SortableTable columns={columnData} />
        </div>
      </div>
    );
  }
}

ReportsTable.propTypes = {
  readInspections: PropTypes.func.isRequired,
  readInspectionSchemas: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => {
  const role = getCurrentUserRole(state);
  const company = getCurrentUserCompany(state);
  return {
    role,
    company,
  };
};

export default connect(mapStateToProps, Object.assign({}, actions))(
  withStyles(styles)(ReportsTable)
);



// WEBPACK FOOTER //
// ./src/modules/inspection/components/ReportsTable.js